/**
 * Auth0ProviderWrapper — Phase A.0.1 (parallel auth).
 *
 * Conditionally wraps the app tree with `Auth0Provider` from
 * `@auth0/auth0-react` when REACT_APP_AUTH_PROVIDER === 'auth0' (or
 * 'both' during the cut-over window). Otherwise it's a passthrough so
 * the existing Emergent Google Auth flow stays untouched.
 *
 * Lives outside the BrowserRouter so we can use `window.history` for
 * the redirect callback without coupling to react-router-dom.
 */
import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";

const PROVIDER = (process.env.REACT_APP_AUTH_PROVIDER || "emergent").toLowerCase();
const DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
const CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;

const auth0Enabled = (PROVIDER === "auth0" || PROVIDER === "both") && !!DOMAIN && !!CLIENT_ID;

const onRedirectCallback = (appState) => {
  // After Auth0 returns to /auth/callback, route the user back to
  // wherever they were trying to go (default: /admin).
  const target = (appState && appState.returnTo) || "/admin";
  window.history.replaceState({}, document.title, target);
};

export const Auth0ProviderWrapper = ({ children }) => {
  if (!auth0Enabled) return children;
  return (
    <Auth0Provider
      domain={DOMAIN}
      clientId={CLIENT_ID}
      cacheLocation="localstorage"
      useRefreshTokens
      authorizationParams={{
        redirect_uri: `${window.location.origin}/auth/callback`,
        audience: AUDIENCE,
        scope: "openid profile email",
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export const isAuth0Enabled = () => auth0Enabled;
export const authProvider = () => PROVIDER;

export default Auth0ProviderWrapper;
